import { Box, Flex, IconButton, Text } from "@chakra-ui/react"
import { faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"


export type ListItemComponentsProps<T> = {
	value: T,
	onUpdate: (item: T) => void
}

type ListItemRenderer<T> = React.FC<ListItemComponentsProps<T>>

export type AddToListButtonProps<T> = {
	label: string,
	onAdd: (item: T) => void
}
export type AddToListButtonComponent<T> = React.FC<{
	onAdd: (item: T) => void
}>

type ListPropertyEditorProps<T> = {
	header: string,
	list: T[],
	onUpdate: (list: T[]) => void,
	RenderComponent: ListItemRenderer<T>,
	AddNewButton: React.ReactNode | undefined
}

const ListPropertyEditor = <T,>({ header, list, onUpdate, RenderComponent, AddNewButton }: ListPropertyEditorProps<T>) => {
	return (
		<Box>
			<Text fontSize="xs" fontWeight="bold" textTransform="uppercase" color="gray.400" mb={3} letterSpacing="wider">
				{header}
			</Text>
			<Flex flexDir='column' gap={2.5} justifyContent='stretch'>
				{list.map((item, index) => (
					<Flex key={index} gap={2} align="center" w="full">
						<RenderComponent
							value={item}
							onUpdate={(newItem) => onUpdate(list.map((oldItem, i) => i === index ? newItem : oldItem))}
						/>
						<IconButton 
							size="sm"
							borderRadius="lg"
							variant="ghost"
							colorScheme="red"
							aria-label="Delete item" 
							icon={<FontAwesomeIcon icon={faTrash} />} 
							onClick={() => {
								onUpdate(list.filter((_, i) => i !== index))
							}} 
						/>
					</Flex>
				))}
				{AddNewButton && (
					<Box pt={1}>
						{AddNewButton}
					</Box>
				)}
			</Flex>
		</Box>
	)
}

export default ListPropertyEditor
